import { motion } from "framer-motion";
import { TypeAnimation } from "react-type-animation";
import heroVideo from "../assets/hero-video.mp4";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function HeroPage() {
  return (
    <>
      <Helmet>
        <title>Nadezhda Venture | Best IT Training in Noida</title>
        <meta name="description" content="Get the best IT training, digital marketing, app development, and web services in Noida with Nadezhda Venture." />
        <meta name="keywords" content="Best IT Training in Noida, Web Development, App Development, Digital Marketing, Virtual Assistant Services" />
        <meta property="og:title" content="Nadezhda Venture | Best IT Training in Noida" />
        <meta property="og:description" content="Nadezhda Venture offers premium IT services including training, web, app development and more." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.yourdomain.com/" />
        <meta property="og:image" content="https://www.yourdomain.com/images/banner.jpg" />
      </Helmet>

      <section className="relative h-[560px] flex items-center justify-center text-white px-4 overflow-hidden">
        
        {/* Background video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover z-0"
        >
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10" />

        {/* Foreground content */}
        <motion.div
          className="relative z-20 max-w-5xl px-6 text-center"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mt-6">
            <TypeAnimation
              sequence={[
                "We're excited to ", 700, "",
                300, " welcome you to ", 700, "",
                300, " Nadezhda Ventures!", 700, "", 300,
              ]}
              wrapper="span"
              speed={15}
              deletionSpeed={15}
              repeat={Infinity}
              cursor={false}
              className="text-orange-500 inline-block"
            />
          </h1>

          <h3 className="mt-6 font-semibold max-w-4xl mx-auto text-lg leading-relaxed">
           At Nadezhda Ventures, we specialize in next-generation web development, mobile app solutions, and digital marketing services that help businesses confidently launch, scale, and grow online. Our innovative strategies are designed to enhance your digital presence, boost engagement, and drive measurable results.
          </h3>

          {/* Blinking Text */}
          {/* <div className="mt-8">
            <p className="text-xl sm:text-2xl font-bold text-orange-600 animate-blink">
              Course Fee started from 3999 Month!
            </p>
          </div> */}
          
          <div className="mt-10 flex flex-col md:flex-row justify-center gap-6">
           <Link
  to="/contact"
  className="bg-white text-orange-700 font-semibold px-6 py-3 rounded hover:bg-gray-100 transition"
>
  Get Started
</Link>

<Link
  to="/services"
  className="border border-white text-white px-6 py-3 rounded hover:bg-white hover:text-orange-700 transition"
>
  View Services
</Link>
          </div>
        </motion.div>
      </section>
    </>
  );
}